import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-product-rooms-slave',
	templateUrl: './product-rooms-slave.component.html',
	styleUrls: ['./product-rooms-slave.component.css'],
})
export class ProductRoomsSlaveComponent {
	@Input() data: any;
	@Input() getRoom: any;
}
